import * as React from 'react';

import { cssClass, fillStyle, flexColumnStyle } from '../../style';
import { FlowOutputStepRunListItemInfo } from '../../ts/models/FlowOutputStepRunInfo';
import { IDataConnectionInfo } from '../../ts/models/IDataConnectionInfo';
import { FlowOutputStepRuns } from '../../ts/resources/FlowOutputStepRuns';
import { Flows } from '../../ts/resources/Flows';
import { FlowInputStep } from '../../ts/ServerApi/types/FlowInputStep';
import { FlowOutputStep } from '../../ts/ServerApi/types/FlowOutputStep';
import { FlowSubplaceProps } from '../types/FlowSubplaceProps';
import { FlowConnectionsDataGridView } from './FlowConnectionsDataGridView';

const cssPrefix = 'FlowConnectionsSubplace';

const rootClass = cssClass(cssPrefix, 'root', fillStyle, flexColumnStyle);
const connectionsClass = cssClass(cssPrefix, 'connections', {
  flex: '1',
  position: 'relative',
});

export type SelectedConnections = { readonly [connectionId: string]: IDataConnectionInfo };

const emptySelection: SelectedConnections = {};

export type FlowSubplaceState = {
  readonly inputSteps: ReadonlyArray<FlowInputStep> | null;
  readonly mostRecentRuns: ReadonlyArray<FlowOutputStepRunListItemInfo> | null;
  readonly outputSteps: ReadonlyArray<FlowOutputStep> | null;
  readonly selectedConnections: SelectedConnections;
};

export class FlowConnectionsSubplace extends React.Component<FlowSubplaceProps, FlowSubplaceState> {
  private unmounted: boolean = false;

  public constructor(props: FlowSubplaceProps) {
    super(props);
    this.state = {
      inputSteps: null,
      mostRecentRuns: null,
      outputSteps: null,
      selectedConnections: emptySelection,
    };
    this.fetchData();
  }

  public componentDidUpdate(prevProps: Readonly<FlowSubplaceProps>, prevState: Readonly<FlowSubplaceState>) {
    if (this.props.flowDetailInfo.id !== prevProps.flowDetailInfo.id) {
      this.fetchData();
    }
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public render(): JSX.Element {
    return (
      <div className={rootClass}>
        <div className={connectionsClass}>
          <FlowConnectionsDataGridView
            angularContext={this.props.angularContext}
            flowAllowedActions={this.props.flowAllowedActions}
            flowDetailInfo={this.props.flowDetailInfo}
            mostRecentRuns={this.state.mostRecentRuns}
            inputSteps={this.state.inputSteps}
            outputSteps={this.state.outputSteps}
            siteUrls={this.props.siteUrls}
            subplace={this.props.place.subplace('connections')}
            translate={this.props.translate}
            selectedConnections={this.state.selectedConnections}
            setSelectedConnections={this.setSelectedConnections}
          />
        </div>
      </div>
    );
  }

  private fetchData() {
    Promise.all([
      Flows.getInputSteps(this.props.flowDetailInfo.id),
      Flows.getOutputSteps(this.props.flowDetailInfo.id),
      FlowOutputStepRuns.getMostRecentForFlow(this.props.flowDetailInfo.id, true)]
    ).then(
      values => {
          if (!this.unmounted) {
            this.setState({
              inputSteps: values[0],
              outputSteps: values[1] as ReadonlyArray<FlowOutputStep>, // TODO: TFSID 1051794: Remove this cast after regression in typescript 3.7 is fixed
              mostRecentRuns: values[2] });
          }
        }
      );
  }

  private readonly setSelectedConnections = (selectedConnections: SelectedConnections) => {
    this.setState({ selectedConnections });
  }

}
